import React, { useState, useEffect } from "react";
import Switch from "react-switch";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import { backendApi } from "../../api/apiService";
import { FaMapPin, FaRupeeSign, FaShoppingBag } from "react-icons/fa";
import { HiStatusOnline } from "react-icons/hi";
import { BsArrowRightCircleFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { BsCalendar2Date } from "react-icons/bs";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useSelector } from "../../components/hooks/hooks";
import { ToastContainer, toast } from "react-toastify";
import { ShimmerCategoryItem } from "react-shimmer-effects";
import {
  FiSearch,
  FiMail,
  FiPhone,
  FiUsers,
  FiCalendar,
  FiMapPin,
} from "react-icons/fi";
import { MdPriorityHigh, MdOutlineCurrencyRupee } from "react-icons/md";
import { MapPin } from "react-feather";
import { BsCashStack } from "react-icons/bs";
import { GrUserExpert } from "react-icons/gr";
import { MdOutlineCategory } from "react-icons/md";
const InitialProcess = () => {
  const { userDetails, userData, userId, siteId } = useSelector(
    (state) => state.login
  );
  const [openings, setOpenings] = useState([]);
  const [Myopenings, setMyOpenings] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      document.getElementById("ProcessingMenu").classList.add("active");
    }, 500);
    getOpenings();
  }, []);

  const getCategoryCount = (candidate, categoryType) => {
    const category = candidate.category.find(
      (cat) => cat.category_type === categoryType
    );
    return category ? category.cnt : 0;
  };

  const getOpenings = () => {
    setLoader(true);
    var req = {
      functionName: "job_opening_Listing",
      site_id: siteId,
      sec_user_id: userId,
    };
    backendApi(req).then((response) => {
      if (response.success === "1") {
        setOpenings(response.skill);
        const filteredSkills = response.skill.filter(job =>
          job.recruiters.some(recruiter => recruiter.recruiter_id === Number(userId) && recruiter.is_active === 1)
        );

        setMyOpenings(filteredSkills);
        setLoader(false);
      } else {
        console.error("error while fetching openings");
        return false;
      }
    });
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  function formatDateToCustomFormat(dateString) {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };

    return new Date(dateString).toLocaleDateString("en-GB", options);
  }

  const navigateToOtherPage = (value) => {
    const yourProp = value;
    const isActive = value.is_active;
    navigate(`/assignRecruiter`, {
      state: {
        props: yourProp,
        is_active: isActive,
      },
    });
  };
  const NavigateClonePage = (value) => {
    navigate(`/CloneRequirement`, {
      state: {
        props: value,
      },
    });
  }

  const navigateToTables = (value, category) => {
    const yourProp = value;
    navigate(`/tables`, {
      state: {
        props: yourProp,
        data: category,
      },
    });
  };
  // const changeActive = (event, candidate) => {
  //   setOpenings(
  //     openings.map((obj) => {
  //       if (candidate.id === obj.id) {
  //         return {
  //           ...obj,
  //           is_active: event === true ? 1 : 0,
  //         };
  //       }
  //       return obj;
  //     })
  //   );
  //   var req = {
  //     functionName: "job_opening_active_deactive",
  //     job_opening_id: candidate.id,
  //     is_active: event,
  //   };
  //   backendApi(req).then((response) => {
  //     if (response.success !== 1) {
  //       // setOpenings(response.skill);
  //       console.error("error while fetching openings");
  //       return false;
  //     }
  //   });
  // };
  const [showModal, setShowModal] = useState(false);
  const [pendingCandidate, setPendingCandidate] = useState(null);
  const [pendingStatus, setPendingStatus] = useState(false);
  const handleSwitchChange = (checked, candidate) => {
    setPendingCandidate(candidate);
    setPendingStatus(checked);
    setShowModal(true);
  };
  const confirmChange = () => {
    const candidate = pendingCandidate;
    const event = pendingStatus;

    setOpenings(
      openings.map((obj) => {
        if (candidate.id === obj.id) {
          return {
            ...obj,
            is_active: event === true ? 1 : 0,
          };
        }
        return obj;
      })
    );

    var req = {
      functionName: "job_opening_active_deactive",
      job_opening_id: candidate.id,
      is_active: event,
    };

    backendApi(req).then((response) => {
      if (response.success !== 1) {
        console.error("Error while fetching openings");
      }
    });

    setShowModal(false);
    setPendingCandidate(null);
  };

  const cancelChange = () => {
    setShowModal(false);
    setPendingCandidate(null);
  };


  const publishToWebsite = (event, candidate) => {
    let tempOpenings = openings.map((obj) => {
      if (obj.id === candidate.id) {
        return {
          ...obj,
          publish_to_website: Number(event.target.checked),
        };
      }
      return {
        ...obj,
      };
    });
    setOpenings(tempOpenings);

    let tempOpeningss = Myopenings.map((obj) => {
      if (obj.id === candidate.id) {
        return {
          ...obj,
          publish_to_website: Number(event.target.checked),
        };
      }
      return {
        ...obj,
      };
    });
    setMyOpenings(tempOpeningss);

    const api = {
      functionName: "publishtowebsite",
      is_active: Number(event.target.checked),
      job_opening_id: candidate.id,
      sec_user_id: userId,
    };
    backendApi(api).then((response) => {
      if (response.success === 1) {
        toast.success(
          `${event.target.checked === true
            ? "Published to Site"
            : "Removed from Site"
          }`,
          { containerId: "D" }
        );
      } else {
        toast.error("Something went wrong in Publish", {
          containerId: "D",
        });
      }
    });
  };
  const [menuClick, setMenuClick] = useState(false);
  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };
  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>
        <ToastContainer
          enableMultiContainer
          containerId={"D"}
          position="bottom-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <Header
            Header="Recruiters"
            toggleMenu={toggleMenu}
            menuClick={menuClick}
          />
          <div className="main-container">
            <div className="card main-card">
              <div className="card-body">
                <Tabs
                  selectedIndex={tabIndex}
                  onSelect={(index) => setTabIndex(index)}
                >
                  <TabList>
                    <Tab>My Jobs</Tab>
                    <Tab>All Jobs</Tab>
                    <Tab>Closed Jobs</Tab>
                  </TabList>
                  <TabPanel>
                    {loader ? (
                      <ShimmerCategoryItem items={12} />
                    ) : (
                      Myopenings.map((candidate, index) => (
                        <div key={index} className="card">
                          {candidate.is_active === 1 && (
                            <div className="card-inner">
                              <div className="row">
                                <div className="col-md-7">
                                  <h4 className="job-view-header">
                                    {candidate.summary}
                                  </h4>
                                  <div className="mb-2">
                                    {/* <span className="label-text">Description :{" "}</span>   */}
                                    <span className="font-Medium ">
                                      {" "}
                                      {candidate.description}
                                    </span>
                                  </div>
                                  <div className="flex-result">
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        <FiCalendar className="me-1" />
                                      </span>
                                      <span className="font-Medium ">
                                        {formatDateToCustomFormat(
                                          candidate.start_date
                                        )}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <HiStatusOnline />
                                      </span>
                                      <span className="font-Medium ">
                                        {" "}
                                        {candidate.status
                                          ? candidate.status
                                          : " Not Available"}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <GrUserExpert />
                                      </span>
                                      <span className="font-Medium ">
                                        {candidate.experiance
                                          ? candidate.experiance
                                          : 0}{" "}
                                        Years{" "}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <BsCashStack />
                                      </span>
                                      <span className="font-Medium ">
                                        {candidate.salary
                                          ? candidate.salary
                                          : 0}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <MdOutlineCategory />
                                      </span>
                                      <span className="font-Medium ">
                                        {candidate.job_type
                                          ? candidate.job_type
                                          : 0}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        <FiMapPin className="me-2" />
                                      </span>
                                      <span className="font-Medium ">
                                        {" "}
                                        {candidate.location
                                          ? candidate.location
                                          : "Not Available"}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <MdPriorityHigh />
                                      </span>
                                      <span className="font-Medium ">
                                        {candidate.priority
                                          ? candidate.priority
                                          : 0}
                                        {"  "}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-5 text-right jobopenings-btn text-md-end text-start my-md-0 my-2">
                                  {["ShortListed", "Hired", "Applied"].map(
                                    (categoryType) => {
                                      const count = getCategoryCount(
                                        candidate,
                                        categoryType
                                      );
                                      if (count > 0) {
                                        return (
                                          <div
                                            key={categoryType}
                                            className={`job-view-header ${categoryType.toLowerCase()}-prof`}
                                            onClick={() =>
                                              navigateToTables(
                                                candidate,
                                                categoryType
                                              )
                                            }
                                          >
                                            {categoryType}
                                            <span className="btn-sub-font">
                                              ({count})
                                            </span>
                                          </div>
                                        );
                                      }
                                      return null;
                                    }
                                  )}
                                </div>
                              </div>
                              <div className="my-2 mb-3">
                                <label className="font-Medium">
                                  <input
                                    type="checkbox"
                                    id="checkWebsite"
                                    checked={Boolean(
                                      candidate.publish_to_website
                                    )}
                                    className="me-2"
                                    onChange={(e) =>
                                      publishToWebsite(e, candidate)
                                    }
                                  ></input>
                                  Publish to Website
                                </label>
                              </div>

                              <div className="row border-top pt-3 mt-2">
                                <div className="col-md-5">
                                  <div className="flex-result">
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        Posted on :{" "}
                                      </span>
                                      <span className="font-Medium ">
                                        {formatDateToCustomFormat(
                                          candidate.created_on
                                        )}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        No of Positions :{" "}
                                      </span>
                                      <span className="font-Medium ">
                                        {candidate.no_of_position
                                          ? candidate.no_of_position
                                          : 0}{" "}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-7">
                                  <div className="d-flex aling-items-center justify-content-end gap-2">
                                    <Switch
                                      className="switch_case mt-1 mr-2"
                                      handleDiameter={16}
                                      height={18}
                                      width={40}
                                      checked={
                                        candidate.is_active === 1 ? true : false
                                      }
                                      // onChange={(checked) => {
                                      //   changeActive(checked, candidate);
                                      // }}
                                      onChange={(checked) => handleSwitchChange(checked, candidate)}
                                    />
                                    <BsArrowRightCircleFill
                                      title="process"
                                      size={26}
                                      onClick={() =>
                                        navigateToOtherPage(candidate)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )
                      ))
                    }

                  </TabPanel>
                  <TabPanel>
                    {loader ? (
                      <ShimmerCategoryItem items={10} />
                    ) : (
                      openings.filter((candidate) => candidate.is_active === 1).map((candidate, index) => (
                        <div key={index} className="card">
                       
                            <div className="card-inner">
                              <div className="row">
                                <div className="col-md-7">
                                  <h4 className="job-view-header">
                                    {candidate.summary}
                                  </h4>
                                  <div className="mb-2">
                                    {/* <span className="label-text">Description :{" "}</span>   */}
                                    <span className="font-Medium ">
                                      {" "}
                                      {candidate.description}
                                    </span>
                                  </div>
                                  <div className="flex-result">
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        <FiCalendar className="me-1" />
                                      </span>
                                      <span className="font-Medium ">
                                        {formatDateToCustomFormat(
                                          candidate.start_date
                                        )}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <HiStatusOnline />
                                      </span>
                                      <span className="font-Medium ">
                                        {" "}
                                        {candidate.status
                                          ? candidate.status
                                          : " Not Available"}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <GrUserExpert />
                                      </span>
                                      <span className="font-Medium ">
                                        {candidate.experiance
                                          ? candidate.experiance
                                          : 0}{" "}
                                        Years{" "}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <BsCashStack />
                                      </span>
                                      <span className="font-Medium ">
                                        {candidate.salary
                                          ? candidate.salary
                                          : 0}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <MdOutlineCategory />
                                      </span>
                                      <span className="font-Medium ">
                                        {candidate.job_type
                                          ? candidate.job_type
                                          : 0}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        <FiMapPin className="me-2" />
                                      </span>
                                      <span className="font-Medium ">
                                        {" "}
                                        {candidate.location
                                          ? candidate.location
                                          : "Not Available"}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <MdPriorityHigh />
                                      </span>
                                      <span className="font-Medium ">
                                        {candidate.priority
                                          ? candidate.priority
                                          : 0}
                                        {"  "}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-5 text-right jobopenings-btn text-md-end text-start my-md-0 my-2">
                                  {["ShortListed", "Hired", "Applied"].map(
                                    (categoryType) => {
                                      const count = getCategoryCount(
                                        candidate,
                                        categoryType
                                      );
                                      if (count > 0) {
                                        return (
                                          <div
                                            key={categoryType}
                                            className={`job-view-header ${categoryType.toLowerCase()}-prof`}
                                            onClick={() =>
                                              navigateToTables(
                                                candidate,
                                                categoryType
                                              )
                                            }
                                          >
                                            {categoryType}
                                            <span className="btn-sub-font">
                                              ({count})
                                            </span>
                                          </div>
                                        );
                                      }
                                      return null;
                                    }
                                  )}
                                </div>
                              </div>
                              <div className="my-2 mb-3">
                                <label className="font-Medium">
                                  <input
                                    type="checkbox"
                                    id="checkWebsite"
                                    checked={Boolean(
                                      candidate.publish_to_website
                                    )}
                                    className="me-2"
                                    onChange={(e) =>
                                      publishToWebsite(e, candidate)
                                    }
                                  ></input>
                                  Publish to Website
                                </label>
                              </div>

                              <div className="row border-top pt-3 mt-2">
                                <div className="col-md-5">
                                  <div className="flex-result">
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        Posted on :{" "}
                                      </span>
                                      <span className="font-Medium ">
                                        {formatDateToCustomFormat(
                                          candidate.created_on
                                        )}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        No of Positions :{" "}
                                      </span>
                                      <span className="font-Medium ">
                                        {candidate.no_of_position
                                          ? candidate.no_of_position
                                          : 0}{" "}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-7">
                                  <div className="d-flex aling-items-center justify-content-end gap-2">
                                    <Switch
                                      className="switch_case mt-1 mr-2"
                                      handleDiameter={16}
                                      height={18}
                                      width={40}
                                      checked={
                                        candidate.is_active === 1 ? true : false
                                      }
                                      // onChange={(checked) => {
                                      //   changeActive(checked, candidate);
                                      // }}
                                      onChange={(checked) => handleSwitchChange(checked, candidate)}
                                    />
                                    <BsArrowRightCircleFill
                                      title="process"
                                      size={26}
                                      onClick={() =>
                                        navigateToOtherPage(candidate)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                         
                        </div>
                      )
                      ))
                    }
                  </TabPanel>
                  <TabPanel>
                    {loader ? (
                      <ShimmerCategoryItem items={10} />
                    ) : (
                      openings.map((candidate, index) => {
                        return (
                          <>
                            {candidate.is_active === 0 && (
                              <div key={index} className="card">
                                <div className="card-inner">
                                  <div className="row">
                                    <div className="col-md-7">
                                      <h4 className="job-view-header">
                                        {candidate.summary}
                                      </h4>
                                      <div className="mb-2">
                                        {/* <span className="label-text">Description :{" "}</span>   */}
                                        <span className="font-Medium ">
                                          {" "}
                                          {candidate.description}{" "}
                                        </span>
                                      </div>
                                      <div className="flex-result">
                                        <div className="flex-sub-div">
                                          <span className="label-text">
                                            <FiCalendar className="me-1" />
                                          </span>
                                          <span className="font-Medium ">
                                            {formatDateToCustomFormat(
                                              candidate.start_date
                                            )}{" "}
                                          </span>
                                        </div>
                                        <div className="flex-sub-div">
                                          <span className="label-text">
                                            <HiStatusOnline className="me-1" />
                                          </span>
                                          <span className="font-Medium ">
                                            {candidate.status
                                              ? candidate.status
                                              : " Not Available"}
                                          </span>
                                        </div>
                                        <div className="flex-sub-div">
                                          <span className="label-text">
                                            <GrUserExpert className="me-1" />
                                          </span>
                                          <span className="font-Medium ">
                                            {candidate.experiance
                                              ? candidate.experiance
                                              : 0}{" "}
                                            Years
                                          </span>
                                        </div>
                                        <div className="flex-sub-div">
                                          <span className="label-text">
                                            <MdOutlineCurrencyRupee className="me-1" />
                                          </span>
                                          <span className="font-Medium ">
                                            {candidate.salary
                                              ? candidate.salary
                                              : 0}
                                          </span>
                                        </div>
                                        <div className="flex-sub-div">
                                          <span className="label-text">
                                            <MdOutlineCategory className="me-1" />
                                          </span>
                                          <span className="font-Medium ">
                                            {candidate.job_type
                                              ? candidate.job_type
                                              : 0}
                                          </span>
                                        </div>
                                        <div className="flex-sub-div">
                                          <span className="label-text">
                                            <FiMapPin className="me-2" />
                                          </span>
                                          <span className="font-Medium ">
                                            {candidate.location
                                              ? candidate.location
                                              : "Not Available"}
                                          </span>
                                        </div>
                                        <div className="flex-sub-div">
                                          <span className="label-text">
                                            <MdPriorityHigh className="me-2" />
                                          </span>
                                          <span className="font-Medium ">
                                            {candidate.priority
                                              ? candidate.priority
                                              : 0}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-5">
                                      {["ShortListed", "Hired", "Applied"].map(
                                        (categoryType) => {
                                          const count = getCategoryCount(
                                            candidate,
                                            categoryType
                                          );
                                          if (count > 0) {
                                            return (
                                              <div
                                                key={categoryType}
                                                className={`job-view-header ${categoryType.toLowerCase()}-prof`}
                                                onClick={() =>
                                                  navigateToTables(
                                                    candidate,
                                                    categoryType
                                                  )
                                                }
                                              >
                                                {categoryType}
                                                <span className="btn-sub-font">
                                                  ({count})
                                                </span>
                                              </div>
                                            );
                                          }
                                          return null;
                                        }
                                      )}
                                    </div>
                                  </div>

                                  <div className="row border-top pt-3 mt-2">
                                    <div className="col-md-5">
                                      <div className="flex-result">
                                        <div className="flex-sub-div">
                                          <span className="label-text">
                                            Posted on :{" "}
                                          </span>
                                          <span className="font-Medium ">
                                            {formatDateToCustomFormat(
                                              candidate.created_on
                                            )}
                                          </span>
                                        </div>
                                        <div className="flex-sub-div">
                                          <span className="label-text">
                                            No of Positions :{" "}
                                          </span>
                                          <span className="font-Medium ">
                                            {candidate.no_of_position
                                              ? candidate.no_of_position
                                              : 0}{" "}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-7">
                                      <div className="ms-auto d-flex aling-items-center gap-2 justify-content-end">
                                        {/* <Switch
                                      className="switch_case mt-1 mr-2"
                                      handleDiameter={16}
                                      height={18}
                                      width={40}
                                      checked={
                                        candidate.is_active === 1 ? true : false
                                      }
                                      onChange={(checked) => {
                                        changeActive(checked, candidate);
                                      }}
                                    /> */}
                                        <button onClick={() => {
                                          NavigateClonePage(candidate)
                                        }} class="btn-btn btn btn-btn2 btn-sm ml-auto">Clone</button>
                                        <BsArrowRightCircleFill
                                          title="process"
                                          size={26}
                                          onClick={() =>
                                            navigateToOtherPage(candidate)
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        );
                      }))}
                  </TabPanel>
                </Tabs>
              </div>
            </div>
          </div>

          {showModal && (
            <div className="modal_parent" id="deletesprint">
              <div className="module_popup deletePeople">
                <div
                  className="module_innerpopup module_bodypop"
                  style={{ background: "#fbfbfb" }}
                >
                  <div className="module_headdiv">
                    <h4 className="popup_head">Please Confirm</h4>
                  </div>
                  <div className="module_body">
                    <div className="py-3">
                      <div>Are you sure you want to change the status?</div>
                      <div>
                        Once the status is changed to inactive, it cannot be reactivated. This action is permanent.
                      </div>
                    </div>
                  </div>
                  <div className="modal_actions">
                    <button
                      type="submit"
                      className="btn-btn btn btn-btn1 me-2"
                      onClick={confirmChange}
                    >
                      Confirm
                    </button>
                    <button
                      type="button"
                      className="btn-btn btn btn-btn2"
                      onClick={cancelChange}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}


        </div>
      </div>
    </>
  );
};

export default InitialProcess;
